const en = {
  text: 'Text',
  signature: 'Signature',
  initials: 'Initials',
  date: 'Date',
  number: 'Number',
  image: 'Image',
  take_photo: 'Take photo',
  file: 'File',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  minimize: 'Minimize',
  payment: 'Payment',
  phone: 'Phone',
  submit_form: 'Submit Form',
  sign_now: 'Sign Now',
  type_here_: 'Type here...',
  optional: 'optional',
  option: 'Option',
  appears_on: 'Appears on',
  page: 'Page',
  select_your_option: 'Select your option',
  complete_hightlighted_checkboxes_and_click: 'Complete hightlighted checkboxes and click',
  submit: 'submit',
  next: 'next',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  send_copy_via_email: 'Send copy via email',
  download: 'Download',
  clear: 'Clear',
  redraw: 'Redraw',
  draw_initials: 'Draw initials',
  type_signature_here: 'Type signature here',
  type_initial_here: 'Type initials here',
  form_has_been_completed: 'Document has been signed!',
  create_a_free_account: 'Create a Free Account',
  signed_with: 'Signed with',
  please_check_the_box_to_continue: 'Please check the box to continue',
  open_source_documents_software: 'Software for Digitally Signing Documents',
  verified_phone_number: 'Verify Phone Number',
  use_international_format: 'Use internatioanl format: +1xxx',
  six_digits_code: '6-digit code',
  change_phone_number: 'Change phone number',
  sending: 'Sending...',
  resend_code: 'Re-send code',
  verification_code_has_been_resent: 'Verification code has been re-sent via SMS',
  please_fill_all_required_fields: 'Please fill all required fields',
  set_today: 'Set Today',
  toggle_multiline_text: 'Toggle Multiline Text',
  draw_signature: 'Draw signature',
  type_initial: 'Type initials',
  draw: 'Draw',
  type: 'Type',
  type_text: 'Type text',
  email_has_been_sent: 'Email has been sent',
  processing: 'Processing',
  pay_with_strip: 'Pay with Stripe',
  reupload: 'Reupload',
  upload: 'Upload',
  files: 'Files'
}

const es = {
  minimize: 'Minimizar',
  text: 'Texto',
  signature: 'Firma',
  initials: 'Iniciales',
  date: 'Fecha',
  number: 'Número',
  image: 'Imagen',
  file: 'Archivo',
  select: 'Seleccionar',
  checkbox: 'Casilla',
  multiple: 'Múltiple',
  radio: 'Radio',
  cells: 'Celdas',
  stamp: 'Sello',
  payment: 'Pago',
  phone: 'Teléfono',
  take_photo: 'Tomar foto',
  submit_form: 'Enviar Formulario',
  sign_now: 'Firmar ahora',
  type_here_: 'Escribe aquí...',
  optional: 'opcional',
  appears_on: 'Aparece en',
  page: 'Página',
  select_your_option: 'Selecciona tu opción',
  complete_hightlighted_checkboxes_and_click: 'Completa las casillas resaltadas y haz clic',
  submit: 'enviar',
  next: 'siguiente',
  click_to_upload: 'Haz clic para cargar',
  or_drag_and_drop_files: 'o arrastra y suelta archivos',
  send_copy_via_email: 'Enviar copia por correo electrónico',
  download: 'Descargar',
  clear: 'Borrar',
  redraw: 'Redibujar',
  draw_initials: 'Dibujar iniciales',
  type_signature_here: 'Escribe la firma aquí',
  type_initial_here: 'Escribe las iniciales aquí',
  form_has_been_completed: '¡El formulario ha sido completado!',
  create_a_free_account: 'Crear una Cuenta Gratuita',
  signed_with: 'Firmado con',
  please_check_the_box_to_continue: 'Por favor marque la casilla para continuar',
  open_source_documents_software: 'software de documentos de código abierto',
  verified_phone_number: 'Verificar número de teléfono',
  use_international_format: 'Usar formato internacional: +1xxx',
  six_digits_code: 'Código de 6 dígitos',
  change_phone_number: 'Cambiar número de teléfono',
  sending: 'Enviando...',
  resend_code: 'Reenviar código',
  verification_code_has_been_resent: 'El código de verificación ha sido reenviado por SMS',
  please_fill_all_required_fields: 'Por favor, complete todos los campos obligatorios',
  set_today: 'Establecer Hoy',
  toggle_multiline_text: 'Alternar Texto Multilínea',
  draw_signature: 'Dibujar firma',
  type_initial: 'Escribir iniciales',
  draw: 'Dibujar',
  type: 'Escribir',
  type_text: 'Escribir texto',
  email_has_been_sent: 'El correo electrónico ha sido enviado',
  processing: 'Procesando',
  pay_with_strip: 'Pagar con Stripe',
  reupload: 'Volver a subir',
  upload: 'Subir',
  files: 'Archivos'
}

const it = {
  minimize: 'Minimizza',
  text: 'Testo',
  signature: 'Firma',
  initials: 'Iniziali',
  date: 'Data',
  number: 'Numero',
  image: 'Immagine',
  file: 'File',
  select: 'Seleziona',
  checkbox: 'Casella di controllo',
  multiple: 'Multiplo',
  radio: 'Radio',
  cells: 'Celle',
  stamp: 'Timbro',
  payment: 'Pagamento',
  phone: 'Telefono',
  submit_form: 'Invia Modulo',
  sign_now: 'Firma ora',
  type_here_: 'Digita qui...',
  optional: 'opzionale',
  appears_on: 'Compare su',
  page: 'Pagina',
  take_photo: 'Scattare una foto',
  select_your_option: 'Seleziona la tua opzione',
  complete_hightlighted_checkboxes_and_click: 'Completa le caselle evidenziate e fai clic',
  submit: 'invia',
  next: 'avanti',
  click_to_upload: 'Clicca per caricare',
  or_drag_and_drop_files: 'oppure trascina e rilascia i file',
  send_copy_via_email: 'Invia copia via email',
  download: 'Scarica',
  clear: 'Cancella',
  redraw: 'Ridisegna',
  draw_initials: 'Disegna iniziali',
  type_signature_here: 'Scrivi la firma qui',
  type_initial_here: 'Scrivi le iniziali qui',
  form_has_been_completed: 'Il modulo è stato completato!',
  create_a_free_account: 'Crea un Account Gratuito',
  signed_with: 'Firmato con',
  please_check_the_box_to_continue: 'Si prega di spuntare la casella per continuare',
  open_source_documents_software: 'software di documenti open source',
  verified_phone_number: 'Verifica numero di telefono',
  use_international_format: 'Usa formato internazionale: +1xxx',
  six_digits_code: 'Codice a 6 cifre',
  change_phone_number: 'Cambia numero di telefono',
  sending: 'Invio in corso...',
  resend_code: 'Rinvia codice',
  verification_code_has_been_resent: 'Il codice di verifica è stato rinviato tramite SMS',
  please_fill_all_required_fields: 'Si prega di compilare tutti i campi obbligatori',
  set_today: 'Imposta Oggi',
  draw_signature: 'Disegna firma',
  type_initial: 'Inserisci iniziali',
  draw: 'Disegna',
  type: 'Inserisci',
  type_text: 'Inserisci testo',
  toggle_multiline_text: 'Attiva Testo Multilinea',
  email_has_been_sent: "L'email è stata inviata",
  processing: 'Elaborazione',
  pay_with_strip: 'Paga con Stripe',
  reupload: 'Ricarica',
  upload: 'Carica',
  files: 'File'
}

const de = {
  minimize: 'Minimieren',
  text: 'Text',
  signature: 'Unterschrift',
  initials: 'Initialen',
  date: 'Datum',
  number: 'Nummer',
  image: 'Bild',
  file: 'Datei',
  select: 'Auswählen',
  checkbox: 'Checkbox',
  multiple: 'Mehrere',
  radio: 'Radio',
  cells: 'Zellen',
  stamp: 'Stempel',
  payment: 'Zahlung',
  phone: 'Telefon',
  submit_form: 'Formular absenden',
  sign_now: 'Jetzt unterschreiben',
  type_here_: 'Hier eingeben...',
  optional: 'optional',
  appears_on: 'Erscheint auf',
  page: 'Seite',
  take_photo: 'Foto aufnehmen',
  select_your_option: 'Wähle deine Option',
  complete_hightlighted_checkboxes_and_click: 'Markierte Kontrollkästchen ausfüllen und klicken',
  submit: 'absenden',
  next: 'weiter',
  click_to_upload: 'Klicken zum Hochladen',
  or_drag_and_drop_files: 'oder Dateien hierher ziehen und ablegen',
  send_copy_via_email: 'Kopie per E-Mail senden',
  download: 'Herunterladen',
  clear: 'Löschen',
  redraw: 'Neu zeichnen',
  draw_initials: 'Initialen zeichnen',
  type_signature_here: 'Unterschrift hier eingeben',
  type_initial_here: 'Initialen hier eingeben',
  form_has_been_completed: 'Formular wurde ausgefüllt!',
  create_a_free_account: 'Kostenloses Konto erstellen',
  signed_with: 'Unterschrieben mit',
  please_check_the_box_to_continue: 'Bitte setzen Sie das Häkchen, um fortzufahren',
  open_source_documents_software: 'Open-Source-Dokumentensoftware',
  verified_phone_number: 'Telefonnummer überprüfen',
  use_international_format: 'Internationales Format verwenden: +1xxx',
  six_digits_code: '6-stelliger Code',
  change_phone_number: 'Telefonnummer ändern',
  sending: 'Senden...',
  resend_code: 'Code erneut senden',
  verification_code_has_been_resent: 'Die Verifizierungscode wurde erneut per SMS gesendet',
  please_fill_all_required_fields: 'Bitte füllen Sie alle erforderlichen Felder aus',
  set_today: 'Heute einstellen',
  draw_signature: 'Unterschrift zeichnen',
  type_initial: 'Initialen eingeben',
  draw: 'Zeichnen',
  type: 'Eingeben',
  type_text: 'Text eingeben',
  toggle_multiline_text: 'Mehrzeiligen Text umschalten',
  email_has_been_sent: 'Die E-Mail wurde gesendet',
  processing: 'Verarbeitung',
  pay_with_strip: 'Mit Stripe bezahlen',
  reupload: 'Erneut hochladen',
  upload: 'Hochladen',
  files: 'Dateien'
}

const fr = {
  minimize: 'Réduire',
  text: 'Texte',
  signature: 'Signature',
  initials: 'Initiales',
  date: 'Date',
  number: 'Numéro',
  image: 'Image',
  file: 'Fichier',
  select: 'Choisir',
  checkbox: 'Coche',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cellules',
  stamp: 'Tampon',
  payment: 'Paiement',
  phone: 'Téléphone',
  submit_form: 'Envoyer le Formulaire',
  sign_now: 'Signer maintenant',
  type_here_: 'Tapez ici...',
  optional: 'facultatif',
  appears_on: 'Apparaît sur',
  page: 'Page',
  take_photo: 'Prendre une photo',
  select_your_option: 'Sélectionnez votre option',
  complete_hightlighted_checkboxes_and_click: 'Complétez les cases à cocher en surbrillance et cliquez',
  submit: 'envoyer',
  next: 'suivant',
  click_to_upload: 'Cliquez pour télécharger',
  or_drag_and_drop_files: 'ou faites glisser-déposer les fichiers',
  send_copy_via_email: 'Envoyer une copie par e-mail',
  download: 'Télécharger',
  clear: 'Effacer',
  redraw: 'Redessiner',
  draw_initials: 'Dessiner les initiales',
  type_signature_here: 'Tapez la signature ici',
  type_initial_here: 'Tapez les initiales ici',
  form_has_been_completed: 'Le formulaire a été complété !',
  create_a_free_account: 'Créer un Compte Gratuit',
  signed_with: 'Signé avec',
  please_check_the_box_to_continue: 'Veuillez cocher la case pour continuer',
  open_source_documents_software: 'logiciel de documents open source',
  verified_phone_number: 'Vérifier le numéro de téléphone',
  use_international_format: 'Utiliser le format international : +1xxx',
  six_digits_code: 'Code à 6 chiffres',
  change_phone_number: 'Changer le numéro de téléphone',
  sending: 'Envoi en cours...',
  resend_code: 'Renvoyer le code',
  verification_code_has_been_resent: 'Le code de vérification a été renvoyé par SMS',
  please_fill_all_required_fields: 'Veuillez remplir tous les champs obligatoires',
  set_today: "Définir Aujourd'hui",
  draw_signature: 'Dessiner une signature',
  type_initial: 'Saisir les initiales',
  draw: 'Dessiner',
  type: 'Saisir',
  type_text: 'Saisir du texte',
  toggle_multiline_text: 'Basculer le Texte Multiligne',
  email_has_been_sent: "L'email a été envoyé",
  processing: 'Traitement',
  pay_with_strip: 'Paiement avec Stripe',
  reupload: 'Recharger',
  upload: 'Télécharger',
  files: 'Fichiers'
}

const pl = {
  minimize: 'Zminimalizuj',
  text: 'Tekst',
  signature: 'Podpis',
  initials: 'Inicjały',
  date: 'Data',
  number: 'Numer',
  image: 'Obraz',
  file: 'Plik',
  select: 'Wybierz',
  checkbox: 'Pole wyboru',
  multiple: 'Wielokrotne',
  radio: 'Radio',
  cells: 'Komórki',
  stamp: 'Pieczątka',
  payment: 'Płatność',
  phone: 'Telefon',
  submit_form: 'Wyślij Formularz',
  sign_now: 'Podpisz teraz',
  type_here_: 'Wpisz tutaj...',
  optional: 'opcjonalny',
  appears_on: 'Pojawia się na',
  page: 'Strona',
  select_your_option: 'Wybierz swoją opcję',
  complete_hightlighted_checkboxes_and_click: 'Wypełnij zaznaczone pola wyboru i kliknij',
  submit: 'wyślij',
  next: 'dalej',
  take_photo: 'Zrób zdjęcie',
  click_to_upload: 'Kliknij, aby przesłać',
  or_drag_and_drop_files: 'lub przeciągnij i upuść pliki',
  send_copy_via_email: 'Wyślij kopię drogą mailową',
  download: 'Pobierz',
  clear: 'Wyczyść',
  redraw: 'Przerysuj',
  draw_initials: 'Narysuj inicjały',
  type_signature_here: 'Wpisz podpis tutaj',
  type_initial_here: 'Wpisz inicjały tutaj',
  form_has_been_completed: 'Formularz został wypełniony!',
  create_a_free_account: 'Utwórz darmowe konto',
  signed_with: 'Podpisane za pomocą',
  please_check_the_box_to_continue: 'Proszę zaznaczyć pole, aby kontynuować',
  open_source_documents_software: 'oprogramowanie do dokumentów open source',
  verified_phone_number: 'Zweryfikuj numer telefonu',
  use_international_format: 'Użyj międzynarodowego formatu: +1xxx',
  six_digits_code: '6-cyfrowy kod',
  change_phone_number: 'Zmień numer telefonu',
  sending: 'Wysyłanie...',
  resend_code: 'Ponownie wyślij kod',
  verification_code_has_been_resent: 'Kod weryfikacyjny został ponownie wysłany',
  please_fill_all_required_fields: 'Proszę wypełnić wszystkie wymagane pola',
  set_today: 'Ustaw Dziś',
  draw_signature: 'Rysuj podpis',
  type_initial: 'Wprowadź inicjały',
  draw: 'Rysuj',
  type: 'Wprowadź',
  type_text: 'Wprowadź tekst',
  toggle_multiline_text: 'Przełącz Tekst Wielolinijkowy',
  email_has_been_sent: 'E-mail został wysłany',
  processing: 'Przetwarzanie',
  pay_with_strip: 'Płatność za pomocą Stripe',
  reupload: 'Ponowne przesłanie',
  upload: 'Przesyłanie',
  files: 'Pliki'
}

const uk = {
  minimize: 'Зменшити',
  text: 'Текст',
  signature: 'Підпис',
  initials: 'Ініціали',
  date: 'Дата',
  number: 'Число',
  image: 'Зображення',
  file: 'Файл',
  select: 'Вибрати',
  checkbox: 'Прапорець',
  multiple: 'Множинний',
  radio: 'Радіо',
  cells: 'Клітинки',
  stamp: 'Штамп',
  payment: 'Платіж',
  phone: 'Телефон',
  submit_form: 'Надіслати Форму',
  sign_now: 'Підписати зараз',
  type_here_: 'Введіть тут',
  optional: 'необов’язково',
  appears_on: "З'являється на",
  page: 'Сторінка',
  take_photo: 'Зробити фото',
  select_your_option: 'Виберіть варіант',
  complete_hightlighted_checkboxes_and_click: 'Заповніть позначені прапорці та натисніть',
  submit: 'надіслати',
  next: 'далі',
  click_to_upload: 'Клацніть, щоб завантажити',
  or_drag_and_drop_files: 'або перетягніть файли сюди',
  send_copy_via_email: 'Надіслати копію електронною поштою',
  download: 'Завантажити',
  clear: 'Очистити',
  redraw: 'Перемалювати',
  draw_initials: 'Намалювати ініціали',
  type_signature_here: 'Введіть підпис тут',
  type_initial_here: 'Введіть ініціали тут',
  form_has_been_completed: 'Форму заповнено!',
  create_a_free_account: 'Створити безкоштовний обліковий запис',
  signed_with: 'Підписано за допомогою',
  please_check_the_box_to_continue: 'Будь ласка, позначте прапорець, щоб продовжити',
  open_source_documents_software: 'відкритий програмний засіб для документів',
  verified_phone_number: 'Підтвердіть номер телефону',
  use_international_format: 'Використовуйте міжнародний формат: +1xxx',
  six_digits_code: '6-значний код',
  change_phone_number: 'Змінити номер телефону',
  sending: 'Надсилаю...',
  resend_code: 'Повторно відправити код',
  verification_code_has_been_resent: 'Код підтвердження був повторно надісланий',
  please_fill_all_required_fields: "Будь ласка, заповніть всі обов'язкові поля",
  set_today: 'Задати Сьогодні',
  draw_signature: 'Намалюйте підпис',
  type_initial: 'Введіть ініціали',
  draw: 'Підпис',
  type: 'Текст',
  type_text: 'Введіть текст',
  toggle_multiline_text: 'Перемкнути Багаторядковий Текст',
  email_has_been_sent: 'Електронний лист був відправлений',
  processing: 'Обробка',
  pay_with_strip: 'Сплатити за допомогою Stripe',
  reupload: 'Перезавантажити',
  upload: 'Завантажити',
  files: 'Файли'
}

const cs = {
  minimize: 'Minimalizovat',
  text: 'Text',
  signature: 'Podpis',
  initials: 'Iniciály',
  date: 'Datum',
  number: 'Číslo',
  image: 'Obrázek',
  file: 'Soubor',
  select: 'Vybrat',
  checkbox: 'Zaškrtávací políčko',
  multiple: 'Více možností',
  radio: 'Rádio',
  cells: 'Buňky',
  stamp: 'Razítko',
  payment: 'Platba',
  phone: 'Telefon',
  submit_form: 'Odeslat formulář',
  sign_now: 'Podepsat nyní',
  type_here_: 'Zadejte zde',
  optional: 'volitelné',
  appears_on: 'Zobrazuje se na',
  page: 'Stránka',
  select_your_option: 'Vyberte svou volbu',
  take_photo: 'Fotit',
  complete_hightlighted_checkboxes_and_click: 'Označte zvýrazněné zaškrtávací políčka a klikněte na',
  submit: 'odeslat',
  next: 'další',
  click_to_upload: 'Klikněte pro nahrání',
  or_drag_and_drop_files: 'nebo přetáhněte soubory sem',
  send_copy_via_email: 'Odeslat kopii e-mailem',
  download: 'Stáhnout',
  clear: 'Smazat',
  redraw: 'Překreslit',
  draw_initials: 'Nakreslit iniciály',
  type_signature_here: 'Sem zadejte podpis',
  type_initial_here: 'Sem zadejte iniciály',
  form_has_been_completed: 'Formulář byl dokončen!',
  create_a_free_account: 'Vytvořit bezplatný účet',
  signed_with: 'Podepsáno pomocí',
  please_check_the_box_to_continue: 'Prosím, zaškrtněte políčko pro pokračování',
  open_source_documents_software: 'open source software pro dokumenty',
  verified_phone_number: 'Ověřte telefonní číslo',
  use_international_format: 'Použijte mezinárodní formát: +1xxx',
  six_digits_code: '6-místný kód',
  change_phone_number: 'Změnit telefonní číslo',
  sending: 'Odesílání...',
  resend_code: 'Znovu odeslat kód',
  verification_code_has_been_resent: 'Ověřovací kód byl znovu odeslán',
  please_fill_all_required_fields: 'Prosím vyplňte všechny povinné položky',
  set_today: 'Nastavit Dnes',
  draw_signature: 'Nakreslit podpis',
  type_initial: 'Zadat iniciály',
  draw: 'Kreslit',
  type: 'Zadat',
  type_text: 'Zadat text',
  toggle_multiline_text: 'Přepnout Víceřádkový Text',
  email_has_been_sent: 'E-mail byl odeslán',
  processing: 'Zpracování',
  pay_with_strip: 'Zaplacení přes Stripe',
  reupload: 'Znovu nahrát',
  upload: 'Nahrát',
  files: 'Soubory'
}

const pt = {
  minimize: 'Minimizar',
  text: 'Texto',
  signature: 'Assinatura',
  initials: 'Iniciais',
  date: 'Data',
  number: 'Número',
  image: 'Imagem',
  file: 'Arquivo',
  select: 'Selecionar',
  checkbox: 'Caixa',
  multiple: 'Múltiplo',
  radio: 'Rádio',
  cells: 'Células',
  stamp: 'Carimbo',
  payment: 'Pagamento',
  phone: 'Telefone',
  submit_form: 'Enviar Formulário',
  sign_now: 'Assinar agora',
  type_here_: 'Digite aqui',
  optional: 'opcional',
  appears_on: 'Aparece em',
  page: 'Página',
  take_photo: 'Tirar foto',
  select_your_option: 'Selecione sua opção',
  complete_hightlighted_checkboxes_and_click: 'Complete as caixas de seleção destacadas e clique',
  submit: 'enviar',
  next: 'próximo',
  click_to_upload: 'Clique para fazer o upload',
  or_drag_and_drop_files: 'ou arraste e solte arquivos',
  send_copy_via_email: 'Enviar cópia por e-mail',
  download: 'Baixar',
  clear: 'Limpar',
  redraw: 'Redesenhar',
  draw_initials: 'Desenhar iniciais',
  type_signature_here: 'Digite a assinatura aqui',
  type_initial_here: 'Digite as iniciais aqui',
  form_has_been_completed: 'O formulário foi concluído!',
  create_a_free_account: 'Criar uma Conta Gratuita',
  signed_with: 'Assinado com',
  please_check_the_box_to_continue: 'Por favor, marque a caixa para continuar',
  open_source_documents_software: 'software de documentos de código aberto',
  verified_phone_number: 'Verificar Número de Telefone',
  use_international_format: 'Use formato internacional: +1xxx',
  six_digits_code: 'Código de 6 dígitos',
  change_phone_number: 'Alterar número de telefone',
  sending: 'Enviando...',
  resend_code: 'Reenviar código',
  verification_code_has_been_resent: 'O código de verificação foi reenviado via SMS',
  please_fill_all_required_fields: 'Por favor, preencha todos os campos obrigatórios',
  set_today: 'Definir Hoje',
  draw_signature: 'Desenhar assinatura',
  type_initial: 'Inserir iniciais',
  draw: 'Desenhar',
  type: 'Inserir',
  type_text: 'Inserir texto',
  toggle_multiline_text: 'Alternar Texto Multilinha',
  email_has_been_sent: 'Email enviado',
  processing: 'Processamento',
  pay_with_strip: 'Pagar com Stripe',
  reupload: 'Reenviar',
  upload: 'Carregar',
  files: 'Arquivos'
}

const he = {
  minimize: 'לקטן',
  text: 'טקסט',
  signature: 'חתימה',
  initials: 'ראשי תיבות',
  date: 'תאריך',
  number: 'מספר',
  image: 'תמונה',
  file: 'קובץ',
  select: 'בחר',
  checkbox: 'תיק בחירה',
  multiple: 'רב ערכים',
  radio: 'רדיו',
  cells: 'תאים',
  stamp: 'חותמת',
  payment: 'תשלום',
  phone: 'טלפון',
  submit_form: 'שלח טופס',
  sign_now: 'חתום כעת',
  type_here_: 'הקלד כאן',
  optional: 'אופציונלי',
  option: 'אפשרות',
  appears_on: 'מופיע ב',
  page: 'עמוד',
  take_photo: 'צלם תמונה',
  select_your_option: 'בחר את האפשרות שלך',
  complete_hightlighted_checkboxes_and_click: 'השלם את תיבות הסימון המודגשות ולחץ',
  submit: 'שליחה',
  next: 'הבא',
  click_to_upload: 'לחץ להעלאה',
  or_drag_and_drop_files: 'או גרור ושחרר קבצים',
  send_copy_via_email: 'שלח עותק באמצעות אימייל',
  download: 'הורדה',
  clear: 'נקה',
  redraw: 'צייר מחדש',
  draw_initials: 'צייר ציוני ראשי תיבות',
  type_signature_here: 'הקלד חתימה כאן',
  type_initial_here: 'הקלד ציוני ראשי תיבות כאן',
  form_has_been_completed: 'הטופס הושלם',
  create_a_free_account: 'צור חשבון חינם',
  signed_with: 'חתום באמצעות',
  please_check_the_box_to_continue: 'אנא סמן את התיבה כדי להמשיך',
  open_source_documents_software: 'תוכנה פתוחה למסמכים',
  verified_phone_number: 'אימות מספר טלפון',
  use_international_format: 'השתמש בפורמט בינלאומי: +1xxx',
  six_digits_code: 'קוד משתמש שש ספרות',
  change_phone_number: 'שינוי מספר טלפון',
  sending: 'שולח',
  resend_code: 'שלח מחדש קוד',
  verification_code_has_been_resent: 'קוד האימות נשלח מחדש בSMS',
  please_fill_all_required_fields: 'אנא מלא את כל השדות הדרושים',
  set_today: 'קבע היום',
  toggle_multiline_text: 'שנה בין טקסט במספר שורות לטקסט בשורה אחת',
  draw_signature: 'צייר חתימה',
  type_initial: 'הקלד ציוני ראשי תיבות',
  draw: 'צייר',
  type: 'הקלד',
  type_text: 'הקלד טקסט',
  email_has_been_sent: 'האימייל נשלח',
  processing: 'מעבד',
  pay_with_strip: 'שלם עם סטרייפ',
  reupload: 'העלה שוב',
  upload: 'העלאה',
  files: 'קבצים'
}

const nl = {
  minimize: 'Minimaliseren',
  text: 'Tekst',
  signature: 'Handtekening',
  initials: 'Initialen',
  date: 'Datum',
  number: 'Nummer',
  image: 'Afbeelding',
  take_photo: 'Maak een foto',
  file: 'Bestand',
  select: 'Selecteer',
  checkbox: 'Aankruisvakje',
  multiple: 'Meerdere',
  radio: 'Radio',
  cells: 'Cellen',
  stamp: 'Stempel',
  payment: 'Betaling',
  phone: 'Telefoon',
  submit_form: 'Formulier verzenden',
  sign_now: 'Nu ondertekenen',
  type_here_: 'Typ hier...',
  optional: 'Optioneel',
  option: 'Optie',
  appears_on: 'Verschijnt op',
  page: 'Pagina',
  select_your_option: 'Selecteer uw optie',
  complete_hightlighted_checkboxes_and_click: 'Voltooi de gemarkeerde selectievakjes en klik',
  submit: 'Voltooien',
  next: 'Volgende',
  click_to_upload: 'Klik om te uploaden',
  or_drag_and_drop_files: 'of sleep en plaats bestanden',
  send_copy_via_email: 'Stuur kopie per e-mail',
  download: 'Downloaden',
  clear: 'Wissen',
  redraw: 'Opnieuw tekenen',
  draw_initials: 'Initialen tekenen',
  type_signature_here: 'Typ hier uw handtekening',
  type_initial_here: 'Typ hier uw initialen',
  form_has_been_completed: 'Formulier is voltooid!',
  create_a_free_account: 'Maak een gratis account aan',
  signed_with: 'Ondertekend met',
  please_check_the_box_to_continue: 'Vink het vakje aan om door te gaan',
  open_source_documents_software: 'Open source documenten software',
  verified_phone_number: 'Geverifieerd telefoonnummer',
  use_international_format: 'Gebruik internationaal formaat: +1xxx',
  six_digits_code: '6-cijferige code',
  change_phone_number: 'Wijzig telefoonnummer',
  sending: 'Voltooien...',
  resend_code: 'Code opnieuw verzenden',
  verification_code_has_been_resent: 'Verificatiecode is opnieuw verzonden via SMS',
  please_fill_all_required_fields: 'Vul alle verplichte velden in',
  set_today: 'Vandaag',
  toggle_multiline_text: 'Schakel meerregelige tekst in/uit',
  draw_signature: 'Handtekening tekenen',
  type_initial: 'Typ initialen',
  draw: 'Tekenen',
  type: 'Typen',
  type_text: 'Typ tekst',
  email_has_been_sent: 'E-mail is verzonden',
  processing: 'Verwerken',
  pay_with_strip: 'Betalen met Stripe',
  reupload: 'Opnieuw uploaden',
  upload: 'Uploaden',
  files: 'Bestanden'
}

const ar = {
  text: 'نص',
  signature: 'توقيع',
  initials: 'الاختصارات',
  date: 'تاريخ',
  number: 'رقم',
  image: 'صورة',
  take_photo: 'التقاط صورة',
  file: 'ملف',
  select: 'اختيار',
  checkbox: 'خانة اختيار',
  multiple: 'متعدد',
  radio: 'راديو',
  cells: 'خلايا',
  stamp: 'ختم',
  minimize: 'تصغير',
  payment: 'الدفع',
  phone: 'هاتف',
  submit_form: 'إرسال النموذج',
  sign_now: 'وقع الآن',
  type_here_: 'اكتب هنا',
  optional: 'اختياري',
  option: 'خيار',
  appears_on: 'يظهر على',
  page: 'صفحة',
  select_your_option: 'اختر خيارك',
  complete_hightlighted_checkboxes_and_click: 'أكمل الخانات المميزة وانقر',
  submit: 'إرسال',
  next: 'التالي',
  click_to_upload: 'انقر للتحميل',
  or_drag_and_drop_files: 'أو اسحب وأسقط الملفات',
  send_copy_via_email: 'إرسال نسخة عبر البريد الإلكتروني',
  download: 'تحميل',
  clear: 'مسح',
  redraw: 'إعادة الرسم',
  draw_initials: 'ارسم الاختصارات',
  type_signature_here: 'اكتب التوقيع هنا',
  type_initial_here: 'اكتب الاختصارات هنا',
  form_has_been_completed: 'تم إكمال النموذج!',
  create_a_free_account: 'إنشاء حساب مجاني',
  signed_with: 'تم التوقيع بواسطة',
  please_check_the_box_to_continue: 'الرجاء التحقق من الخانة للمتابعة',
  open_source_documents_software: 'برنامج وثائق مفتوح المصدر',
  verified_phone_number: 'تحقق من رقم الهاتف',
  use_international_format: 'استخدم الشكل الدولي: +1xxx',
  six_digits_code: 'رمز مكون من 6 أرقام',
  change_phone_number: 'تغيير رقم الهاتف',
  sending: 'جارٍ الإرسال',
  resend_code: 'إعادة إرسال الرمز',
  verification_code_has_been_resent: 'تم إعادة إرسال رمز التحقق عبر الرسائل القصيرة',
  please_fill_all_required_fields: 'الرجاء ملء جميع الحقول المطلوبة',
  set_today: 'تعيين اليوم',
  toggle_multiline_text: 'تبديل النصوص متعددة الأسطر',
  draw_signature: 'ارسم التوقيع',
  type_initial: 'اكتب الاختصارات',
  draw: 'ارسم',
  type: 'اكتب',
  type_text: 'اكتب نصًا',
  email_has_been_sent: 'تم إرسال البريد الإلكتروني',
  processing: 'جارٍ المعالجة',
  pay_with_strip: 'الدفع بواسطة Stripe',
  reupload: 'إعادة التحميل',
  upload: 'تحميل',
  files: 'الملفات'
}

const i18n = { en, es, it, de, fr, pl, uk, cs, pt, he, nl, ar }

export default i18n
